import DiagnosticPage from "pages/diagnostics/DiagnosticPage";
import React from "react";
import { Route } from "react-router";

export const DiagnosticRoutes = <Route path="diagnostics" element={<DiagnosticPage />} />;
